"use client";

import { Button } from "@relume_io/relume-ui";
import React from "react";

export function CtaFigmaForStorytelling() {
  return (
    <section className="relative overflow-hidden px-[5%] py-16 md:py-24 lg:py-28">
      {/* Background SVG */}
      <div className="absolute inset-0 z-0">
        <svg
          className="h-full w-full opacity-10"
          viewBox="0 0 800 600"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient id="grid-gradient" x1="0%" y1="0%" x2="100%" y2="100%">
              <stop offset="0%" stopColor="#60A5FA" />
              <stop offset="100%" stopColor="#A78BFA" />
            </linearGradient>
          </defs>
          <pattern
            id="grid"
            width="40"
            height="40"
            patternUnits="userSpaceOnUse"
          >
            <path
              d="M 40 0 L 0 0 0 40"
              fill="none"
              stroke="url(#grid-gradient)"
              strokeWidth="1"
            />
          </pattern>
          <rect width="100%" height="100%" fill="url(#grid)" />
        </svg>
      </div>

      {/* Content */}
      <div className="relative z-10 container max-w-lg mx-auto text-center">
        <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-blue-500/10 border border-blue-500/20 text-blue-400 mb-6">
          <span className="text-sm font-medium">Featured</span>
        </div>
        <h2 className="mb-5 text-5xl font-bold md:mb-6 md:text-7xl lg:text-8xl leading-[1.3] pb-4">
          <span className="bg-clip-text text-transparent bg-gradient-to-r from-blue-400 to-purple-400 pr-6">
            "Figma for Storytelling"
          </span>
        </h2>
        <p className="md:text-lg text-gray-300">
          A revolutionary approach to visual storytelling that combines the intuitive design of Figma
          with powerful narrative tools. Create, collaborate, and bring your stories to life.
        </p>
        <div className="mt-8 flex items-center justify-center gap-4 md:mt-10">
          <Button
            title="Get Started"
            className="bg-gradient-to-r from-blue-500 to-purple-500 hover:from-blue-600 hover:to-purple-600"
            onClick={() => window.location.href = '/contact?type=product'}
          >
            Get Started
          </Button>
          <Button
            title="Watch Demo"
            variant="secondary"
            className="border-blue-500/20 text-blue-400 hover:bg-blue-500/10"
            onClick={() => {
              document.getElementById('demo-video').scrollIntoView({ behavior: 'smooth' });
            }}
          >
            Watch Demo
          </Button>
        </div>
      </div>
    </section>
  );
}
